export const auth_token="$3ingT0k3n"
export const route_home="/task-master/home"
export const routes={
    home:"/task-master/home",
    createTask:"/task-master/create-task",
    viewTasks:"/task-master/view-task",
    userManage:"/task-master/user-management",
    roleManage:"/task-master/role-management",
    privManage:"/task-master/privilege-management",
}
